export default function HorizontalSplit({ left, right }: any) {
  return (
    <div className="flex items-center">
      <div className="w-8/12">{left}</div>
      <div className="flex w-4/12 justify-end">{right}</div>
    </div>
  );
}
